import { useMemo } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { generateComponents } from './generate-components';

export const GeneratedUI = ({
  schema, propertiesSchema, customComponentTypes, ...dynamicProperties
}) => {
  const dynamicComponentBuilders = useMemo(() => generateComponents({ schema, customComponentTypes }), [schema, customComponentTypes]);

  const completedComponents = useMemo(
    () =>
      _.map(dynamicComponentBuilders, componentBuilder => componentBuilder.build(propertiesSchema, dynamicProperties)),
    [dynamicComponentBuilders, dynamicProperties, propertiesSchema]
  );

  return completedComponents;
};

GeneratedUI.propTypes = {
  schema: PropTypes.shape({}).isRequired,
};
